//
// toggle mortgage types on home loan checkbox select
//

var toggleMortgageTypesVisibility = (function () {
    'use strict';

    // Variables

    var $validate = true;
    const $mortgageTypesId = "mortgage-types";
    const inlineCheckBoxes = $(`#${$mortgageTypesId}`).find("input[type='checkbox']");
    const $mortgageCheckboxIdSelector = "mortgage-checkbox";
    const $inlineCheckBoxesContainerIdSelector = "mortgage-types-container";
    const $emaWording = "Mortgage - Equity Management Account (EMA)";
    const qOneHeading = $(`input[name='can_maintain_curr_min_monthly_repayment']`).parents(".form-group").find("legend");
    const qOneOriginal = "For the account/s you have selected above, can you maintain your current minimum contractual repayments?";
    const qOneVariation = "For the account/s you have selected above, can you maintain regular repayments to reduce the balance?";
    const qTwoHeading = $(`input[name='can_maintain_partial_repayment']`).parents(".form-group").find("legend");
    const qTwoOriginal = "For the account/s you have selected above can you maintain a partial repayment?";
    const qTwoVariation = "For the account/s you have selected above, can you maintain regular payments?";
    const bizOverdraftValue = "Business Overdraft";
    const consumerOverdraftValue = "Consumer Overdraft";


    // Methods
    function checkValidity() {
        var hasChecked = $(`#${$mortgageTypesId}`).find("input[type='checkbox']:checked").length > 0;

        if (hasChecked || !$validate) {

            if (!$validate) {
                $("input[name='mortgageTypes']").prop("checked", false);
            }
            
            $(inlineCheckBoxes[0]).removeAttr('required');
            inlineCheckBoxes[0].setCustomValidity('');
        }
        else {
            $(inlineCheckBoxes[0]).attr('required', 'required');
            const errorMessage = 'At least one checkbox must be selected.';
            inlineCheckBoxes[0].setCustomValidity(errorMessage);
        }
    }

    function toggleInlineCheckBoxesVisibility() {
        var mortgageTypesCheckBoxesContainer = $(`#${$inlineCheckBoxesContainerIdSelector}`);

        if (mortgageTypesCheckBoxesContainer.css('display') === 'none') {
            $validate = true;
            mortgageTypesCheckBoxesContainer.css("display", "flex");
            for (let i = 0; i < inlineCheckBoxes.length; i++) {
                inlineCheckBoxes[i].addEventListener('change', checkValidity);
            }

            checkValidity();
        }
        else {
            mortgageTypesCheckBoxesContainer.css("display", "none");
            $validate = false;
            checkValidity();
        }
    };

    function mortgageTypesOnChange() {
        var selectedAccTypes = [];
        $(`input[name='accounts']:checked`).each(function () {
            selectedAccTypes.push($(this).val());
        });

        if (this.checked) {
            if ($(this).val() === $emaWording && $(`input[name='mortgageTypes']`).filter(':checked').length === 1) {
                if (!(selectedAccTypes.indexOf("Personal Loan") > -1) && !(selectedAccTypes.indexOf("Consumer Credit Card") > -1)
                    && !(selectedAccTypes.indexOf("Small Business Loan") > -1) && !(selectedAccTypes.indexOf("Esanda or Asset Finance") > -1)
                    && !(selectedAccTypes.indexOf("Business Credit Card") > -1)) {
                    changeAccountQuestionsHeading(false);
                }
            }
            else {
                changeAccountQuestionsHeading(true);
            }
        }
        else {
            var selectedMortgageTypes = [];
            $(`input[name='mortgageTypes']:checked`).each(function () {
                selectedMortgageTypes.push($(this).val());
            });
            if (selectedMortgageTypes.indexOf("Mortgage - Equity Management Account (EMA)") > -1 && selectedMortgageTypes.length === 1) {
                if (!(selectedAccTypes.indexOf("Personal Loan") > -1) && !(selectedAccTypes.indexOf("Consumer Credit Card") > -1)
                    && !(selectedAccTypes.indexOf("Small Business Loan") > -1) && !(selectedAccTypes.indexOf("Esanda or Asset Finance") > -1)
                    && !(selectedAccTypes.indexOf("Business Credit Card") > -1)) {
                    changeAccountQuestionsHeading(false);
                }
            }
            else {
                changeAccountQuestionsHeading(true);
            }
        }
    }

    function changeAccountQuestionsHeading(isOriginal) {
        if (isOriginal) {
            qOneHeading.text(qOneOriginal);
            qTwoHeading.text(qTwoOriginal);
            qOneHeading.append("<sup class='text-danger'><i class='fas fa-asterisk'></i></sup>");
            qTwoHeading.append("<sup class='text-danger'><i class='fas fa-asterisk'></i></sup>");
        }
        else {
            qOneHeading.text(qOneVariation);
            qTwoHeading.text(qTwoVariation);
            qOneHeading.append("<sup class='text-danger'><i class='fas fa-asterisk'></i></sup>");
            qTwoHeading.append("<sup class='text-danger'><i class='fas fa-asterisk'></i></sup>");
        }
    }

    function accountsTypesOnChange() {
        var selected = [];
        $(`input[name='accounts']:checked`).each(function () {
            selected.push($(this).val());
        });

        var selectedMortgages = [];
        $(`input[name='mortgageTypes']:checked`).each(function () {
            selectedMortgages.push($(this).val());
        });

        if (this.checked) {
            if ($(this).val() === consumerOverdraftValue || $(this).val() === bizOverdraftValue) {
                if (!(selected.indexOf("Personal Loan") > -1) && !(selected.indexOf("Consumer Credit Card") > -1)
                    && !(selected.indexOf("Small Business Loan") > -1) && !(selected.indexOf("Esanda or Asset Finance") > -1)
                    && !(selected.indexOf("Business Credit Card") > -1) && !(selectedMortgages.indexOf("Mortgage - Owner Occupied (O/O)") > -1)
                    && !(selectedMortgages.indexOf("Mortgage - Investment") > -1)) {
                    changeAccountQuestionsHeading(false);
                }
            }
            else {
                changeAccountQuestionsHeading(true);
            }
        }
        else {
            if ((selected.indexOf("Business Overdraft") > -1 || selected.indexOf("Consumer Overdraft") > -1 || selectedMortgages.indexOf("Mortgage - Equity Management Account (EMA)") > -1)) {
                if (!(selected.indexOf("Personal Loan") > -1) && !(selected.indexOf("Consumer Credit Card") > -1)
                    && !(selected.indexOf("Small Business Loan") > -1) && !(selected.indexOf("Esanda or Asset Finance") > -1)
                    && !(selected.indexOf("Business Credit Card") > -1) && !(selectedMortgages.indexOf("Mortgage - Owner Occupied (O/O)") > -1)
                    && !(selectedMortgages.indexOf("Mortgage - Investment") > -1)) {
                    changeAccountQuestionsHeading(false);
                }
            }
            else {
                changeAccountQuestionsHeading(true);
            }
        }
    }

    function init() {
        $(document).ready(function () {
            $(`#${$mortgageCheckboxIdSelector}`).change(toggleInlineCheckBoxesVisibility);
            $(`input[name='mortgageTypes']`).change(mortgageTypesOnChange);
            $(`input[name='accounts']`).change(accountsTypesOnChange);
        });
    }

    if ($(`#${$mortgageTypesId}`).length) {
        init();
    }

})();